import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';

/**
 * CNN LIVE LEGEND - SLIM CONTINUOUS GRADIENT
 * Estilo premium basado en Contrail RF
 */

const GRADIENT = "linear-gradient(90deg, #feffbcff 0%, #ff4800ff 50%, #962fdbc8 100%)";

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  pointerEvents: "none",
  marginTop: "-4px",
  opacity: 1,
  transition: "opacity .25s ease",
}));

const Title = styled(Box)(({ theme }) => ({
  display: 'block',
  textAlign: 'center',
  marginBottom: '6px',
  fontSize: '0.7rem',
  fontWeight: 900,
  letterSpacing: '.06em',
  textTransform: 'uppercase',
  color: '#1a237e',
  textShadow: '0 1px 2px rgba(255,255,255,0.8)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px'
}));

const LegendBar = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "220px",
  height: "18px",
  background: GRADIENT,
  borderRadius: "20px",
  overflow: "hidden",
  boxShadow: "0 4px 12px rgba(0,0,0,0.12), inset 0 1px 2px rgba(255,255,255,0.5)",
  border: "1px solid rgba(255,255,255,0.8)",
  position: 'relative',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 15px',
  [theme.breakpoints.down('sm')]: {
    width: "220px",
  }
}));

const Label = styled(Box)(({ theme }) => ({
  color: "#000",
  fontWeight: 900,
  fontSize: "0.65rem",
  textTransform: "uppercase",
  letterSpacing: "0.02em",
  textShadow: "0 0 3px rgba(255,255,255,1), 0 0 1px #fff",
  pointerEvents: 'none',
  zIndex: 1
}));

export default function RiskSelectorCNN_WMS() {
  return (
    <Container>
      <Title>
        <ThunderstormIcon sx={{ fontSize: 13 }} />
        CONVECTIVE Risk
      </Title>
      
      <LegendBar>
        <Label>Low</Label>
        <Label>Medium</Label>
        <Label>High</Label>
      </LegendBar>

      <Box sx={{
        display: 'block',
        textAlign: 'center',
        mt: 0.5,
        fontSize: "0.6rem",
        fontWeight: 700,
        color: '#666',
        letterSpacing: '0.05em'
      }}>
        {/* zoom and click to see values! */}
      </Box>
    </Container>
  );
}
